import { Stack, TextField, Typography } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { luxonFormats, luxonViews } from "../blockTypes";

type Props = {
  currentBlock: any;
};

const InitialsFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const position = currentBlock?.config?.position;
  const isMultiline = currentBlock?.config?.allowMultiline;
  const type = currentBlock?.config?.type;
  const format = currentBlock?.config?.format;
  const [tempDate, setTempDate] = useState(null);

  return (
    <Stack gap={1} direction={position === "top" ? "column-reverse" : "column"}>
      <Typography variant="subtitle1" fontWeight="regular">
        {label}
      </Typography>
      {type === "text" && (
        <TextField
          name="label"
          fullWidth
          multiline={isMultiline}
          rows={isMultiline ? 3 : 1}
        />
      )}
      {type === "date" && (
        <DateTimePicker
          format={luxonFormats?.[format]}
          views={luxonViews?.[format]}
          value={tempDate}
          onChange={(newDate) => setTempDate(newDate)}
          slotProps={{
            textField: {
              fullWidth: true,
              InputProps: {
                readOnly: true,
                placeholder: "Select date",
              },
            },
            field: {
              readOnly: true,
            },
          }}
        />
      )}
    </Stack>
  );
};
export default InitialsFieldPreview;
